import { useState } from "react";
import PageHeader from "../-components/PageHeader";
import Seo from "components/Seo";
import DriverForm, { DriverFormState } from "./DriverForm";

export default function ConsoleDriverCreate() {
    const [form, setForm] = useState<DriverFormState>({ driver_no: null, name: "", phone: "", car_no: "" });

    return (
        <>
            <Seo type="console" pageTitle="기사 관리" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="기사 등록" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        <div className="bg-white rounded-[20px] py-[36px] px-[40px] min-w-[800px]">
                            <DriverForm form={form} setForm={setForm} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
